import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="period-filter-bar"
//
// Toggles the visibility of the underlying date inputs when the "Custom"
// rolling preset is pressed, so the controls only appear when the user
// is editing a custom range.
export default class extends Controller {
  static targets = ["dateForm"]

  toggleCustom(event) {
    if (event) event.preventDefault()
    if (!this.hasDateFormTarget) return
    this.dateFormTarget.classList.toggle("hidden")
  }
}
